/**
 * Living style-guide for this Yote application
 *
 * TODO:  This needs a lot of work
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import global components
import AuthoringLayout from '../../admin/components/AuthoringLayout.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";

class AuthoringDashboard extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return  (
      <AuthoringLayout>
        <Helmet
          title={"Authoring Home | Pro-ficiency"}
        />
        <div className="flex">
          <section className="section">
            <div className="yt-container style-guide">
              <h1> Welcome to the RedStone authoring tool. Select one of the tabs above to begin authoring. </h1>
              <div className="content" style={{height:"200vh"}}/>
            </div>
          </section>
        </div>
      </AuthoringLayout>
    )
  }
}

export default AuthoringDashboard;



// WEBPACK FOOTER //
// modules/admin/views/AuthoringDashboard.js.jsx